import { Controller } from '@hotwired/stimulus';

// TODO: review and consolidate with survey_task_controller.js

export default class extends Controller {
  static targets = ['form', 'submitButton'];

  initialize() {
    this.nextTaskButton = document.querySelector('.task-button.next');
    this.preventNextTask = this.preventNextTask.bind(this);
    this.nextTaskButton.addEventListener('click', this.preventNextTask);
  }

  disconnect() {
    if (!this.nextTaskButton) return;
    this.nextTaskButton.removeEventListener('click', this.preventNextTask); // Remove the event listener
  }

  preventNextTask(event) {
    if (this.nextTaskButton && this.nextTaskButton.classList.contains('disabled')) {
      event.preventDefault();
      return;
    }
  }

  change() {
    if (this.hasSubmitButtonTarget && this.checkFormCompletion()) {
      this.submitButtonTarget.removeAttribute('disabled');
    }
  }

  checkFormCompletion() {
    if (!this.hasFormTarget) return false;

    const allInputs = this.formTarget.querySelectorAll('input, select, textarea');
    return Array.from(allInputs).every(input => {
      if (input.dataset.required === 'false') return true; // Skip required check if data-required is false
      if (input.type === 'checkbox' || input.type === 'radio') {
        return Array.from(this.formTarget.querySelectorAll(`input[name="${input.name}"]`)).some(checkbox => checkbox.checked);
      }
      return input.value.trim() !== '';
    });
  }
}
